import React, { useRef, useState } from "react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

import "./music.scss";

interface Song {
  src: string;
  name: string;
  duration: string
}

export default function Music() {
  const [currentSong, setCurrentSong] = useState<Song>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const playerRef = useRef(null);

  const songs: Song[] = [{
    src: "/assets/music/king_of_kings.m4a",
    name: "King of Kings",
    duration: "4:49"
  }, {
    src: "/assets/music/gott_vode_wunder.m4a",
    name: "Gott vode Wunder",
    duration: "4:54"
  }, {
    src: "/assets/music/holy_forever.m4a",
    name: "Holy Forever",
    duration: "5:03"
  }, {
    src: "/assets/music/d_gueti_vo_gott.m4a",
    name: "D'Güeti vo Gott",
    duration: "3:40"
  }, {
    src: "/assets/music/hymn_of_heaven.m4a",
    name: "Hymn of Heaven",
    duration: "4:21"
  }, {
    src: "/assets/music/use_vater.m4a",
    name: "Üse Vater",
    duration: "4:25"
  },];

  const handleSongClick = (song: Song) => {
    if (song?.name === currentSong?.name) {
      if (isPlaying) {
        playerRef.current.audio.current.pause();
      } else {
        playerRef.current.audio.current.play();
      }
    } else {
      setCurrentSong(song);
    }
  };

  const playNextSong = () => {
    const currentSongIndex = songs.findIndex(song => currentSong.name === song.name);
    const nextSong = songs[currentSongIndex + 1];
    if (nextSong) {
      handleSongClick(nextSong);
    }
  }

  return (
    <div className="app-body flex-grow-1 bg-light-gradient">
      <div className="container my-3">
        <div className="row d-flex align-items-start">
          <div className="col-12 col-xxl-3 col-xl-4 col-lg-5 col-md-5">
            <img className="rounded-4 bg-light" src="/assets/music/cover.jpg" alt="Cover Acoustic Worship"/>
          </div>

          <div className="col-12 col-xxl-9 col-xl-8 col-lg-7 col-md-7">
            <h1 className="my-2">Acoustic Worship</h1>
            <h4 className="my-2">Sven Niklaus; Jan Niklaus</h4>

            <button className="btn btn-dark btn-lg rounded-4" onClick={() => handleSongClick(songs[0])}>
              {
                isPlaying ? (
                  <i className="bi bi-pause-fill me-2"></i>
                ) : (
                  <i className="bi bi-play-fill me-2"></i>
                )
              }
              Alle Abspielen
            </button>
            {
              songs.map(song => {
                return (
                  <div key={song.name}
                       className="song-container row bg-white bg-opacity-10 fs-4 mx-1 my-3 p-3 pb-2 rounded-4"
                       onClick={() => handleSongClick(song)}>
                    <div className="col-10">
                      {
                        song?.name === currentSong?.name && isPlaying ? (
                          <i className="bi bi-pause-fill me-2"></i>
                        ) : (
                          <i className="bi bi-play-fill me-2"></i>
                        )
                      }
                      {song.name}
                    </div>
                    <div className="col-2 text-end fs-5">{song.duration}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
      {
        currentSong && (
          <div className="container mb-5">
            <div className="row">
              <div className="w-100 bg-black rounded-4">
                <AudioPlayer
                  ref={playerRef}
                  className="rounded-4"
                  src={currentSong.src}
                  autoPlay={true}
                  layout="horizontal"
                  showJumpControls={false}
                  customAdditionalControls={[]}
                  showFilledVolume={true}
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                  onEnded={() => playNextSong()}
                />
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
}